import React from 'react'
import styled from 'styled-components'

import OpenLinkIconImg from '../../images/openLinkIcon.svg'

type Props = {
  children: React.ReactNode
  href: string
  size: number
}

export const Link: React.FC<Props> = props => (
  <HyperLink href={props.href} size={props.size} target="_blank">
    {props.children}
    <OpenLinkIcon src={OpenLinkIconImg} size={props.size} />
  </HyperLink>
)

const HyperLink = styled.a<{ size: number }>`
  cursor: pointer;
  color: #0892c7;
  font-size: ${props => props.size}px;
  line-height: 14px;
  text-decoration-line: underline;
`

const OpenLinkIcon = styled.img<{ size: number }>`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  padding-left: ${props => props.size * 0.2}px;
  margin: auto;
`
